<!--简历编辑-个人介绍-->
<template>
	<div class="self-introduction">

		<h3 class="c-title">个人简介
			<a href="javascript:;" class="btn-add" :class="{'disabled':isEditting||!this.editable}" v-if="status!=0" @click="callOutEditModal">
				<i class="icon">
					<img src="../../assets/img/common/icon-pencil.png" v-if="!isEditting&&editable"/>
					<img src="../../assets/img/common/icon-pencil-off.png" v-else="isEditting||!editable"/>
				</i>
				<span>&nbsp;编辑</span>
			</a>
		</h3>

		<!--初始状态-->
		<div class="no-data" v-if="status==0" v-cloak>
			<resume-undone-template blockText="个人简介" :showTitle="false" :editable="editable" @editBtnClick="firstAdd" />
		</div>

		<!--展示-->
		<div class="introduction-complete" v-if="!showEditBox&&status==1" v-cloak>
			<div class="introduction" v-html="introductionBackUp"></div>
		</div>

		<!--编辑窗口-->
		<div class="editting" v-if="showEditBox" v-cloak>
			<div class="row-24-block">
				<!--<label class="label">个人简介</label>-->
				<textarea class="base-textarea" placeholder="请输入个人简介" style="height: 125px;" maxlength="1000" v-model="introduction"></textarea>
				<p class="error-tips" v-show="introductionError">个人简介不可以为空</p>
			</div>
			<div class="row-24-block no-mb">
				<a href="javascript:;" class="btn-operation btn-save" @click="resumeSelfIntroductionEditSave">保存</a>
				<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeSelfIntroductionEditCancel">取消</a>
			</div>
		</div>

	</div>
</template>

<script>
	//接口1.获取个人简介信息 2.个人简介编辑
	import { httpResumeSelfIntroductionGet, httpResumeSelfIntroductionEdit } from '@/api/resume'
	import ResumeUndoneTemplate from '@/components/EditResume/ResumeUndoneTemplate.vue'

	export default {
		name: 'ResumeSelfIntroduction',
		props: {
			resumeId: {
				type: Number,
				required: true
			},
			editable: {
				type: Boolean,
				required: true
			}
		},
		components: {
			ResumeUndoneTemplate
		},
		data() {
			return {
				status: 0, //0-初始状态，1-污染状态
				showEditBox: false,
				isEditting: false,
				introduction: '',
				introductionBackUp: '', //每次请求接口的时候拿一次，其他操作不改变此值，用作取消编辑时不作任何改变
				introductionError: false
			}
		},
		mounted() {
			setTimeout(() => {
				this.resumeSelfIntroductionGet();
			}, 160)
		},
		methods: {

			//初次编辑
			firstAdd() {
				this.showEditBox = true;
				this.isEditting = true;
				this.status = 1;
			},

			//打开编辑操作窗口
			callOutEditModal() {
				if(!this.editable) return;
				this.isEditting = true;
				this.showEditBox = true;
				this.status = 1;
				this.$emit('set-edit-status', 1);
			},

			//保存编辑
			resumeSelfIntroductionEditSave() {
				let oData = {
					resumeId: this.resumeId,
					content: this.introduction,
				};

				if(this.introduction.trim() === this.introductionBackUp.trim()) {
					this.$message({
						type: 'warning',
						message: '您尚未做任何修改',
						duration: 1200
					})
					return;
				}

				if(this.introduction.length == 0) {
					this.$message({
						type: 'warning',
						message: '您的个人简介不能为空',
						duration: 1200
					});
					this.introductionError = true;
					return;
				} else {
					this.introductionError = false;
				}

				httpResumeSelfIntroductionEdit(oData).then(r => {
					console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '保存成功',
							duration: 1200,
						})
						this.resumeSelfIntroductionGet();
						this.status = 1;
						this.showAddBox = false;
						this.isEditting = false;
						this.$emit('set-edit-status', 2);
					} else {
						//console.log(r);
						this.$message.error('保存失败，请稍后再试。');
					}
				}).catch(err => {
					console.log(err);
					this.$message.error('保存失败，请稍后再试。');
				});
			},

			//取消保存，不做任何操作
			resumeSelfIntroductionEditCancel() {
				this.setPageStatus();
				this.$emit('set-edit-status', 2);
			},

			//获取个人简介信息
			resumeSelfIntroductionGet() {
				if(!this.resumeId) {
					this.status = 0;
					return
				};

				let prama = this.resumeId;
				httpResumeSelfIntroductionGet(prama).then(r => {
					//console.log(r);
					if(r.success) {
						this.introduction = (r.data|| '').toString().replace(/<br>/g, '\n') ;
						this.introductionBackUp = r.data || '';
						this.setPageStatus();
						if(this.introduction) {
							this.status = 1;
						}
					} else {
						this.status = 0;
					}
				}).catch(err => {
					console.log(err);
					this.$notify({
						type: 'warning',
						title: '警告',
						message: '获取简历个人简介失败'
					});
				});
			},

			//判断页面显示状态
			setPageStatus() {
				this.introductionBackUp.length == 0 ? this.status = 0 : this.status = 1;
				this.isEditting = false;
				this.showEditBox = false;
			}

		} //methods结束
	}
</script>

<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
	.self-introduction {
		margin-bottom: 30px;
	}
	
	.introduction {
		color: #666;
		line-height: 34px;
		font-size: 14px;
		padding-bottom: 30px;
		margin-bottom: 30px;
		border-bottom: 1px solid #eee;
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeSelfIntroduction.vue